import {Link, navigate} from "gatsby";
import {Redirect, Router} from "@reach/router";
import React, {useEffect, useState} from "react";
import {
  Box,
  CircularProgress,
  Collapse,
  Container,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  withStyles,
} from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import MainLayout from "../components/MainLayout";
import AccessKeys from "../components/dashboard/AccessKeys";
import UserInfo from "../components/dashboard/UserInfo";
import OwnerOrdersList from "../components/orders/OrdersList";
import SupportOrdersList from "../components/support/SupportOrdersList";
import FullApp from "../fullapp";
import SupportOrderDetailsPanel from "../components/support/SupportOrderDetailsPanel";
import {callApi} from "../actions/base";
import AvailablePackages from "../components/packages/AvailablePackages";
import UserPackages from "../components/packages/UserPackages";
import OrderDetails from "../components/orders/OrderDetails";
import {HTTP_METHOD} from "../constants/http";
import SupportBankAccountOrdersList from "../components/support/SupportBankAccountOrdersList";
import SupportBankAccountOrderDetails from "../components/support/SupportBankAccountOrderDetails";

const styles = theme => ({
  loader: {
    color: "#1e5abb",
  },
  menuSidebar: {
    padding: theme.spacing(2),
    marginTop: "0",
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
});

const onLogoutSuccess = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  navigate("/login");
};

const handleLogout = () => {
  const uri = "/auth/logout";
  callApi(uri, {}, onLogoutSuccess, console.error, HTTP_METHOD.GET);
};

const Dashboard = ({location, classes}) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [nestedOpen, setNestedOpen] = useState(null);

  const onError = (data, status) => {
    if (status === 401) onLogoutSuccess();
  };

  const onSuccess = data => {
    setUser(data);
    setLoading(false);
  };

  useEffect(() => {
    const uri = "/auth/user";
    callApi(uri, null, onSuccess, onError, HTTP_METHOD.GET);
  }, []);

  if (loading) {
    return (
      <MainLayout>
        <Container>
          <Box textAlign="center">
            <CircularProgress className={classes.loader}/>
          </Box>
        </Container>
      </MainLayout>
    );
  }

  return (
    <FullApp>
      <MainLayout>
        <Grid container>
          <Grid item xs={12} md={2} className={classes.menuSidebar}>
            <List component="nav">
              <Link to="/dashboard/user">
                <ListItem
                  button
                  selected={location.pathname === "/dashboard/user"}
                >
                  <ListItemText primary="Dane konta"/>
                </ListItem>
              </Link>

              <ListItem button onClick={() => setNestedOpen(!nestedOpen)}>
                <ListItemText primary="Pakiety"/>
                {nestedOpen ? <ExpandLess/> : <ExpandMore/>}
              </ListItem>
              <Collapse in={nestedOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <Link to="/dashboard/packages/current">
                    <ListItem
                      button
                      className={classes.nested}
                      selected={
                        location.pathname === "/dashboard/packages/current"
                      }
                    >
                      <ListItemText primary="Twoje pakiety"/>
                    </ListItem>
                  </Link>
                  <Link to="/dashboard/packages/available">
                    <ListItem
                      button
                      className={classes.nested}
                      selected={
                        location.pathname === "/dashboard/packages/available"
                      }
                    >
                      <ListItemText primary="Kup pakiet"/>
                    </ListItem>
                  </Link>
                </List>
              </Collapse>

              <Link to="/dashboard/orders">
                <ListItem
                  button
                  selected={location.pathname === "/dashboard/orders"}
                >
                  <ListItemText primary="Lista zleceń"/>
                </ListItem>
              </Link>

              <Link to="/dashboard/keys">
                <ListItem
                  button
                  selected={location.pathname === "/dashboard/keys"}
                >
                  <ListItemText primary="Klucze API"/>
                </ListItem>
              </Link>

              {user.role === "support" && (
                <>
                  <Link to="/dashboard/verification/bank-accounts">
                    <ListItem
                      button
                      selected={location.pathname === "/dashboard/verification/bank-accounts"}
                    >
                      <ListItemText primary="Weryfikacje - konta bankowe"/>
                    </ListItem>
                  </Link>
                  <Link to="/dashboard/verification">
                    <ListItem
                      button
                      selected={location.pathname === "/dashboard/verification"}
                    >
                      <ListItemText primary="Weryfikacje"/>
                    </ListItem>
                  </Link>
                </>
              )}

              <Divider/>

              <Link>
                <ListItem button onClick={handleLogout}>
                  <ListItemText primary="Wyloguj"/>
                </ListItem>
              </Link>
            </List>
          </Grid>
          <Grid item xs={12} md={10}>
            <Router>
              <UserInfo path="/dashboard/user" user={user}/>
              <AccessKeys path="/dashboard/keys" user={user}/>
              <AvailablePackages path="/dashboard/packages/available"/>
              <UserPackages path="/dashboard/packages/current"/>
              <SupportBankAccountOrdersList path="/dashboard/verification/bank-accounts" user={user}/>
              <SupportBankAccountOrderDetails path="/dashboard/verification/bank-accounts/:code" user={user}/>
              <SupportOrdersList path="/dashboard/verification" user={user}/>
              <SupportOrderDetailsPanel
                user={user}
                path="/dashboard/verification/:code"
              />
              <OwnerOrdersList path="/dashboard/orders" user={user}/>
              <OrderDetails path="/dashboard/orders/:code" user={user}/>
              <Redirect
                noThrow
                from="/dashboard"
                to="/dashboard/user"
                default
              />
            </Router>
          </Grid>
        </Grid>
      </MainLayout>
    </FullApp>
  );
};

export default withStyles(styles)(Dashboard);
